"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[767],{

/***/ 9024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6734);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1776);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7280);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6631);




function RateBadge(param) {
    let { rate , textClassName  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("flex items-center space-x-1 text-sm", textClassName),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_3__/* .MdStar */ .MVI, {
                className: "relative -top-[1px] w-4 h-4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: rate
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(RateBadge));


/***/ }),

/***/ 6562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6734);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1776);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3906);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8757);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7280);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1689);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var utils_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8728);







function BookNow(param) {
    let { uniqueIdentifier , type , id , buttonWide , hasLongTitle  } = param;
    const { locale  } = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const { t  } = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("common");
    if (!uniqueIdentifier) return null;
    const href = (0,utils_utils__WEBPACK_IMPORTED_MODULE_6__/* .generateBookingURL */ ._2)({
        uniqueIdentifier,
        type,
        id,
        locale
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
        href: href,
        className: classnames__WEBPACK_IMPORTED_MODULE_4___default()("flex items-center justify-center border border-primary-500 text-sm rounded-lg text-primary-text bg-primary-500 uppercase font-medium hover:bg-primary-300 hover:border-primary-300 transition-colors cursor-pointer", {
            "py-2 px-8": buttonWide
        }, {
            "py-3 px-5": !buttonWide
        }),
        children: hasLongTitle && t("global.booknow") || t("global.book")
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(BookNow));


/***/ }),

/***/ 2132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Card; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6734);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1776);


function Card(param) {
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "relative p-4 rounded-lg border border-zinc-200",
        children: children
    });
}


/***/ }),

/***/ 4737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6734);

const Loading = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex items-center justify-center py-8 rounded-lg text-zinc-700",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                "aria-hidden": "true",
                role: "status",
                className: "mr-2 w-5 h-5 text-zinc-300 animate-spin fill-primary-500",
                viewBox: "0 0 100 101",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                        fill: "currentFill"
                    })
                ]
            }),
            "Loading..."
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Loading);


/***/ }),

/***/ 1057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6734);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8779);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_1__);


const SafelySetInnerHTML = (param)=>{
    let { htmlText  } = param;
    const cleanedHTML = isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_1___default().sanitize(htmlText);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        dangerouslySetInnerHTML: {
            __html: cleanedHTML
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SafelySetInnerHTML);


/***/ }),

/***/ 9767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ List_providers; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(6734);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(1776);
// EXTERNAL MODULE: ./node_modules/lodash-es/chunk.js + 7 modules
var chunk = __webpack_require__(1663);
// EXTERNAL MODULE: ./hooks/useFetch.ts + 1 modules
var useFetch = __webpack_require__(9350);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(7832);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/BookNow/BookNow.tsx
var BookNow = __webpack_require__(6562);
// EXTERNAL MODULE: ./components/Cards/Card.tsx
var Card = __webpack_require__(2132);
// EXTERNAL MODULE: ./components/Badges/Rate.badge.tsx
var Rate_badge = __webpack_require__(9024);
// EXTERNAL MODULE: ./hooks/useReadmore.ts + 1 modules
var useReadmore = __webpack_require__(1123);
// EXTERNAL MODULE: ./utils/utils.ts
var utils = __webpack_require__(8728);
// EXTERNAL MODULE: ./components/Render/HTML.render.tsx
var HTML_render = __webpack_require__(1057);
;// CONCATENATED MODULE: ./components/Provider/Provider.card.tsx










const DOMAIN_URL = "https://www.yocale.com";
const ProviderCard = (param)=>{
    let { id , title , description , rate , imageUrl , unavailableItems  } = param;
    const unavailableItem = (0,react.useMemo)(()=>{
        return unavailableItems === null || unavailableItems === void 0 ? void 0 : unavailableItems.reduce((obj, cur)=>({
                ...obj,
                [cur]: true
            }), {});
    }, [
        unavailableItems
    ]);
    const [truncated, hasLimit] = (0,useReadmore/* default */.Z)(description || "", 320);
    const { data: businessProfile  } = (0,useFetch/* useBusinessProfile */.jB)();
    const widgetSetting = businessProfile === null || businessProfile === void 0 ? void 0 : businessProfile.data.widget;
    const providerLink = "".concat(DOMAIN_URL, "/widget/").concat(widgetSetting === null || widgetSetting === void 0 ? void 0 : widgetSetting.uniqueIdentifier, "/provider/").concat((0,utils/* toSearchEngineFriendlyWords */.Eh)(title), "/").concat(id);
    const isImageHidden = unavailableItem === null || unavailableItem === void 0 ? void 0 : unavailableItem.image;
    const isRateHidden = unavailableItem === null || unavailableItem === void 0 ? void 0 : unavailableItem.rate;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex gap-4 sm:gap-8 items-start flex-col sm:flex-row",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex-auto",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: providerLink,
                            target: "_blank",
                            className: "hover:text-primary-500",
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                className: "font-medium text-lg mb-1",
                                children: title
                            })
                        }),
                        !isRateHidden && /*#__PURE__*/ (0,jsx_runtime.jsx)(Rate_badge/* default */.Z, {
                            textClassName: "text-primary-500",
                            rate: rate.score
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "text-sm mt-2 text-[#46474a] leading-6 break-word",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HTML_render/* default */.Z, {
                                    htmlText: truncated
                                }),
                                hasLimit && " ..."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full sm:w-auto min-w-[9rem] max-w-none sm:max-w-[9rem] flex-none flex flex-col space-y-3 justify-end sm:pl-4",
                    children: [
                        !isImageHidden && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative aspect-[1.6] sm:aspect-[1.18] overflow-hidden",
                            children: (imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                className: "w-full h-full bg-gray-200 rounded-lg object-cover select-none",
                                src: imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.url,
                                alt: (imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.alt) || title,
                                width: 300,
                                height: 254,
                                quality: 90,
                                loading: "lazy"
                            }) || /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute inset-0 rounded-lg flex items-center justify-center bg-gray-200 text-gray-500",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    className: "w-6 h-6",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    fill: "none",
                                    viewBox: "0 0 32 32",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        fill: "currentColor",
                                        d: "M11.8 18.75c-3.276 0-9.8 1.839-9.8 5.5V27h19.6v-2.75c0-3.661-6.524-5.5-9.8-5.5Zm-6.524 5.107a12.407 12.407 0 0 1 6.524-1.964c2.315.033 4.575.713 6.524 1.964H5.276ZM11.8 16c2.7 0 4.9-2.467 4.9-5.5S14.5 5 11.8 5s-4.9 2.467-4.9 5.5S9.1 16 11.8 16Zm0-7.857a2.237 2.237 0 0 1 2.1 2.357 2.237 2.237 0 0 1-2.1 2.357A2.237 2.237 0 0 1 9.7 10.5a2.237 2.237 0 0 1 2.1-2.357Zm9.856 10.7A6.792 6.792 0 0 1 24.4 24.25V27H30v-2.75c0-3.174-4.9-4.982-8.344-5.407ZM20.2 16c2.7 0 4.9-2.467 4.9-5.5S22.9 5 20.2 5a4.4 4.4 0 0 0-2.1.55 9.45 9.45 0 0 1 0 9.9 4.401 4.401 0 0 0 2.1.55Z"
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BookNow/* default */.Z, {
                            uniqueIdentifier: widgetSetting === null || widgetSetting === void 0 ? void 0 : widgetSetting.uniqueIdentifier,
                            type: "provider",
                            id: id,
                            buttonWide: true
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Provider_card = (ProviderCard);

// EXTERNAL MODULE: ./components/Loading/Loading.tsx
var Loading = __webpack_require__(4737);
// EXTERNAL MODULE: ./hooks/useVirtualized.ts + 1 modules
var useVirtualized = __webpack_require__(1764);
;// CONCATENATED MODULE: ./containers/Providers/List.providers.tsx







function ProvidersList(param) {
    let {} = param;
    const { data: businessProfile  } = (0,useFetch/* useBusinessProfile */.jB)();
    const widgetSetting = businessProfile === null || businessProfile === void 0 ? void 0 : businessProfile.data;
    const unavailableItems = widgetSetting === null || widgetSetting === void 0 ? void 0 : widgetSetting.widget.settings.provider.unavailableItems;
    const { data , error , fetchNextPage , isFetching , isFetchingNextPage , status  } = (0,useFetch/* useProvider */.yL)(widgetSetting === null || widgetSetting === void 0 ? void 0 : widgetSetting.key);
    const providers = (0,react.useMemo)(()=>data ? data.pages.flatMap((page)=>page.items) : [], [
        data
    ]);
    const chunkyData = (0,react.useMemo)(()=>(0,chunk/* default */.Z)(providers, 2), [
        providers
    ]);
    const lastPage = data === null || data === void 0 ? void 0 : data.pages[data.pageParams.length - 1];
    const hasNextPage = (lastPage === null || lastPage === void 0 ? void 0 : lastPage.hasNext) || false;
    const { parentRef , rowVirtualizer , items , totalSize  } = (0,useVirtualized/* default */.Z)({
        fetchNextPage,
        isFetchingNextPage,
        hasNextPage,
        length: chunkyData.length
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            status === "loading" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {}) : status === "error" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                children: [
                    "Error: ",
                    error.message
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: parentRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative w-full",
                    style: {
                        height: totalSize
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-0 left-0 w-full",
                        style: {
                            transform: "translateY(".concat(items[0].start - rowVirtualizer.options.scrollMargin, "px)")
                        },
                        children: items.map((virtualRow)=>{
                            const isLoaderRow = virtualRow.index > chunkyData.length - 1;
                            const row = chunkyData[virtualRow.index];
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                "data-index": virtualRow.index,
                                ref: rowVirtualizer.measureElement,
                                className: "grid grid-cols-1 lg:grid-cols-2 gap-4 pb-4",
                                children: isLoaderRow ? hasNextPage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {}) : "Nothing more to load" : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: row.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Provider_card, {
                                            id: item.id,
                                            description: item.description,
                                            rate: item.rate,
                                            title: item.name,
                                            imageUrl: item.image,
                                            unavailableItems: unavailableItems
                                        }, item.id))
                                })
                            }, virtualRow.key);
                        })
                    })
                })
            }),
            isFetching && !isFetchingNextPage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {}) : null
        ]
    });
}
/* harmony default export */ var List_providers = (/*#__PURE__*/(0,react.memo)(ProvidersList));


/***/ }),

/***/ 1123:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useReadmore; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(1776);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(8757);
;// CONCATENATED MODULE: ./utils/truncate.utils.ts
function truncate(text, options) {
    const { length , separator =" " , ellipsis ="..." , keepHtml =false  } = options;
    let truncatedText = text;
    // Handle HTML tags
    let htmlTags = [];
    if (!keepHtml) {
        truncatedText = text.replace(/<[^>]*>/g, (match)=>{
            htmlTags.push(match);
            return "";
        });
    }
    // Truncate by word boundary
    if (truncatedText.length > length) {
        const words = truncatedText.split(separator);
        let truncatedWords = words.slice(0, Math.max(1, words.length - 1));
        while(truncatedWords.join(separator).length + ellipsis.length > length){
            truncatedWords.pop();
        }
        truncatedText = truncatedWords.join(separator) + ellipsis;
    }
    // Add back HTML tags
    if (!keepHtml && htmlTags.length > 0) {
        truncatedText = htmlTags.reverse().reduce((text, tag)=>tag + text, truncatedText);
    }
    return truncatedText;
}
/* harmony default export */ var truncate_utils = (truncate);

;// CONCATENATED MODULE: ./hooks/useReadmore.ts



function useReadMore(text) {
    let limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 170;
    const { t  } = (0,useTranslation/* default */.Z)("common");
    const [isReadMore, setIsReadMore] = (0,react.useState)(false);
    const handleBreakLines = text.replace(/\n/g, "<br>");
    const hasLimit = text.length > limit;
    const truncatedText = truncate_utils(handleBreakLines, {
        length: limit,
        separator: " ",
        ellipsis: "",
        keepHtml: true
    });
    const description = isReadMore ? handleBreakLines : truncatedText;
    const helperText = isReadMore ? t("global.showless") : t("global.showmore");
    const onClickButton = ()=>setIsReadMore((prevState)=>!prevState);
    return [
        description,
        hasLimit,
        helperText,
        onClickButton,
        isReadMore
    ];
}
/* harmony default export */ var useReadmore = (useReadMore);


/***/ }),

/***/ 1764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hooks_useVirtualized; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(1776);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-virtual/build/lib/index.mjs + 4 modules
var lib = __webpack_require__(3398);
;// CONCATENATED MODULE: ./hooks/useOnScreen.ts

const useOnScreen = function(ref) {
    let rootMargin = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "0px";
    const [isIntersecting, setIntersecting] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        const observer = new IntersectionObserver((param)=>{
            let [entry] = param;
            // Update our state when observer callback fires
            setIntersecting(entry.isIntersecting);
        }, {
            rootMargin
        });
        if (ref.current) {
            observer.observe(ref.current);
        }
    }, [
        ref,
        rootMargin
    ]); // Empty array ensures that effect is only run on mount and unmount
    return isIntersecting;
};
/* harmony default export */ var hooks_useOnScreen = (useOnScreen);

;// CONCATENATED MODULE: ./hooks/useVirtualized.ts



const useVirtualized = (param)=>{
    let { isFetchingNextPage , hasNextPage , length , options , fetchNextPage  } = param;
    const parentOffsetRef = (0,react.useRef)();
    const parentRef = (0,react.useRef)(null);
    const onScreen = hooks_useOnScreen(parentRef);
    const opts = {
        count: hasNextPage ? length + 1 : length,
        scrollMargin: parentOffsetRef.current,
        estimateSize: ()=>100,
        initialOffset: 3,
        overscan: 2,
        ...options
    };
    (0,react.useEffect)(()=>{
        if (onScreen) {
            var _parentRef_current;
            var _parentRef_current_offsetTop;
            parentOffsetRef.current = (_parentRef_current_offsetTop = (_parentRef_current = parentRef.current) === null || _parentRef_current === void 0 ? void 0 : _parentRef_current.offsetTop) !== null && _parentRef_current_offsetTop !== void 0 ? _parentRef_current_offsetTop : 0;
        }
    }, [
        parentRef,
        onScreen
    ]);
    const rowVirtualizer = (0,lib/* useWindowVirtualizer */.hO)(opts);
    const totalSize = rowVirtualizer.getTotalSize();
    const items = rowVirtualizer.getVirtualItems();
    (0,react.useEffect)(()=>{
        const [lastItem] = [
            ...items
        ].reverse();
        if (!lastItem) {
            return;
        }
        if (lastItem.index >= length - 1 && hasNextPage && !isFetchingNextPage && onScreen) {
            fetchNextPage();
        }
    }, [
        hasNextPage,
        fetchNextPage,
        length,
        isFetchingNextPage,
        items,
        onScreen
    ]);
    return {
        parentRef,
        rowVirtualizer,
        items,
        totalSize
    };
};
/* harmony default export */ var hooks_useVirtualized = (useVirtualized);


/***/ }),

/***/ 8728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BB": function() { return /* binding */ isProd; },
/* harmony export */   "Ee": function() { return /* binding */ generateSocialShare; },
/* harmony export */   "Eh": function() { return /* binding */ toSearchEngineFriendlyWords; },
/* harmony export */   "Hl": function() { return /* binding */ getNameOfDay; },
/* harmony export */   "UT": function() { return /* binding */ generateSectionLabel; },
/* harmony export */   "V5": function() { return /* binding */ formatTime24; },
/* harmony export */   "_2": function() { return /* binding */ generateBookingURL; },
/* harmony export */   "aS": function() { return /* binding */ truncateString; },
/* harmony export */   "dO": function() { return /* binding */ resolvedPublicPath; }
/* harmony export */ });
/* harmony import */ var lodash_es_lowerCase__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7167);
/* harmony import */ var lodash_es_kebabCase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(194);


const DOMAIN_URL = "https://www.yocale.com";
const getNameOfDay = ()=>{
    const days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ];
    const d = new Date();
    return days[d.getDay()];
};
const generateBookingURL = (param)=>{
    let { uniqueIdentifier , type , id , locale  } = param;
    let link = "".concat(DOMAIN_URL, "/widget/").concat(uniqueIdentifier, "?lng=").concat(locale);
    switch(type){
        case "location":
            link += "&locations=".concat(id);
            break;
        case "provider":
            link += "&op=~".concat(id);
            break;
        case "service":
            link += "&op=".concat(id, "~");
            break;
        default:
            break;
    }
    return link;
};
const generateSocialShare = (param)=>{
    let { type , businessName , url  } = param;
    let link = "";
    switch(type){
        case "facebook":
            link += "https://facebook.com/sharer/sharer.php?u=".concat(url);
            break;
        case "twitter":
            link += "https://twitter.com/intent/tweet/?text=".concat(businessName, "&url=").concat(url);
            break;
        default:
            break;
    }
    return link;
};
const formatTime24 = (timeString)=>{
    const [hourString, minute] = timeString.split(":");
    const hour = +hourString % 24;
    return (hour % 12 || 12) + ":" + minute + (hour < 12 ? "AM" : "PM");
};
const truncateString = function(str) {
    let num = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 13;
    if (str.length <= num) {
        return str;
    }
    return str.slice(0, num) + "...";
};
const isProd = ()=>"production" === "production";
const resolvedPublicPath = (path)=>isProd() ? "/b/".concat(path) : "/".concat(path);
const toSearchEngineFriendlyWords = (input)=>{
    return encodeURIComponent((0,lodash_es_kebabCase__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,lodash_es_lowerCase__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(input)));
};
const generateSectionLabel = function(label, fallback) {
    let limit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 13;
    if (!label) return fallback;
    return truncateString(label, limit);
};



/***/ })

}]);